


























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component<EmojiOptionSelector>({
})
export default class EmojiOptionSelector extends Vue {
  @Prop({ type: Number }) private selected
  @Prop({ type: Boolean }) private readOnly

  public NPSValues = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

  public isOpen = false
}
